<template>
    <div class="home">
        <div class="topBanner">
            <div class="bannerTop">
                <div class="bannerTopLeft">
                    <div class="bannerTopLeftTitle">欢迎回来</div>
                    <div class="bannerTopLeftDesc">运营数据中心</div>
                </div>
                <div class="bannerTopRight">
                    <div class="newsBtn">
                        <Icon name="bell" class="messageIcon" :badge="totalResult.unReadMessageCount" size="6vw"
                            color="#FFFFFF" @click="toPage('/message')" />
                    </div>
                </div>
            </div>
            <div class="bannerTopCount">
                <div class="bannerBottomTitle">总金额(元)</div>
                <div class="bannerBottomNumber">¥{{ totalResult.totalAmount }}</div>
            </div>


            <div class="bannerBottom">

                <div class="bannerBottomItem">
                    <div class="bannerBottomTitle" @click="showTipe">运营网点(家)
                        <icon name="question-o" color="#FFFFFF" />
                    </div>
                    <div class="bannerBottomNumber">{{ totalResult.storeWithDeviceCount }}</div>
                </div>
                <div class="bannerBottomItem">
                    <div class="bannerBottomTitle">昨日收益(元)</div>
                    <div class="bannerBottomNumber">¥{{ totalResult.yesterdayAmount }}</div>
                </div>
            </div>
        </div>
        <div class="mainContent">

            <div class="searchBtnView">
                <div class="tabBtnView">
                    <div class="btnItem" :class="activeType === 'PROFIT_AMOUNT' ? 'active' : ''"
                        @click="onTab('PROFIT_AMOUNT')">收益最佳</div>
                    <div class="btnItem" :class="activeType === 'CREATE_TIME' ? 'active' : ''"
                        @click="onTab('CREATE_TIME')">最新创建</div>
                </div>
                <div class="searchInputView">
                    <Icon name="search" size="3.5vw" color="#c3c3c3" />
                    <form action="" onsubmit="return false;">
                        <input type="search" placeholder="输入网点名称" v-model="storeName" @keyup.13="onSearch" />
                    </form>
                </div>

            </div>
            <div class="storeList">
                <storeItem v-for="(item, index) in storeList" :item="item" :key="index" :show-device-count="true" />
                <Button class="loadingMoreBtn" size="mini" v-if="isLoadMore" @click="loadMore">展开查看更多</Button>
                <Divider v-else>暂无更多数据</Divider>
            </div>
        </div>



           <TabBar :activeIndex="0" />
    </div>
</template>

<script>
/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/4 11:41 上午
* 首页
*/
import TabBar from '../../components/TabBar'
import { Icon, Button, Divider } from 'vant'
import storeItem from '../../components/storeItem'
import { getIndexTotal, getStoreList as getStoreListApi } from "../../api/home";

export default {
    name: "Home",
    components: {
        TabBar, Icon, storeItem, Button, Divider
    },
    data() {
        return {
            activeType: 'PROFIT_AMOUNT',
            storeName: '',    // 列表的过滤
            page: 1,
            totalResult: {
                storeWithDeviceCount: 0,
                totalAmount: 0,
                unReadMessageCount: 0,
                yesterdayAmount: 0,
            },
            storeList: [],
            isLoadMore: true,    // 列表是否可加载更多
        }
    },
    created() {
        getIndexTotal().then(result => {
            this.totalResult = result;
        });
        this.getStoreList();
    },
    methods: {
        showTipe() {
            this.toast({
                text: '有绑定设备的网点数量'
            })
        },
        getStoreList() {
            let { storeName, activeType, page } = this;
            getStoreListApi({ orders: activeType, storeName, page }).then(result => {
                this.storeList = [...this.storeList, ...result.records];
                if (result.records.length < 10) {
                    this.isLoadMore = false;
                }
            })
        },
        onTab(activeType) {
            this.activeType = activeType;
            this.storeList = [];
            this.page = 1;
            this.getStoreList();
        },
        onSearch() {
            this.storeList = [];
            this.page = 1;
            this.getStoreList();
        },
        loadMore() {
            this.page += 1;
            this.getStoreList();
        }
    }
}
</script>

<style lang='less' scoped>
.home {
    min-height: 100vh;
    padding-bottom: 50px;
    background-color: #f8f8f8;
    box-sizing: border-box;

    .topBanner {
        width: 100%;
        height: 70.07vw;
        background: linear-gradient(135deg, #43a2fe 0%, #2d8ce8 100%);
        border-bottom-right-radius: 24px;
        border-bottom-left-radius: 24px;
        padding: 4vw;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .bannerTop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4vw;

            .bannerTopLeft {
                .bannerTopLeftTitle {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 3.47vw;
                    margin-bottom: 1vw;
                }

                .bannerTopLeftDesc {
                    color: #ffffff;
                    font-size: 6vw;

                }
            }

            .bannerTopRight {
                display: flex;
                align-items: center;

                .newsBtn {
                    width: 10vw;
                    height: 10vw;
                    background-color: rgba(255, 255, 255, 0.15);
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

        }

        .bannerTopCount {
            width: 100%;

            margin-bottom: 2vw;
            padding: 2vw;
            background-color: rgba(255, 255, 255, 0.15);

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 2.67vw;
            box-sizing: border-box;

            .bannerBottomTitle {
                color: rgba(255, 255, 255, 0.7);
                margin-bottom: 2vw;
                font-size: 3.47vw;
            }

            .bannerBottomNumber {
                font-size: 6vw;
                color: rgba(255, 255, 255, 1);
            }
        }

        .bannerBottom {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .bannerBottomItem {
                padding: 2vw;
                flex: 1;
                background-color: rgba(255, 255, 255, 0.15);

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-radius: 2.67vw;

                .bannerBottomTitle {
                    color: rgba(255, 255, 255, 0.7);
                    margin-bottom: 2vw;
                    font-size: 3.47vw;
                }

                .bannerBottomNumber {
                    font-size: 6vw;
                    color: rgba(255, 255, 255, 1);
                }

                &:nth-child(1) {
                    margin-right: 2vw;
                }
            }
        }
    }

    .mainContent {
        transform: translateY(-8.5vw);
        /**上移元素**/
        padding: 4vw;
        box-sizing: border-box;
        z-index: 1;
    }



    .searchBtnView {
        padding: 3.5vw;
        display: flex;
        align-items: start;
        flex-direction: column;
        justify-content: center;
        height: 27.2vw;
        background-color: #ffffff;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
        border-radius: 2.67vw;
        box-sizing: border-box;


        .tabBtnView {
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            margin-bottom: 2vw;

            .btnItem {
                font-size: 3.2vw;
                color: rgba(107, 114, 128, 1);
                background-color: rgba(243, 244, 246, 1);
                padding: 2vw;
                border-radius: 5vw;

                &.active {
                    position: relative;
                    // color: #43a2fe;
                    color: rgba(67, 162, 254, 1);
                    background-color: rgba(67, 162, 254, 0.1);

                }

                &:nth-child(1) {
                    margin-right: 2vw;
                }
            }
        }

        .searchInputView {
            flex: 1;
            display: flex;
            align-items: center;
            width: 100%;
            padding: 0 2vw;
            background-color: #f7f7f7;
            border-radius: 3.67vw;
            box-sizing: border-box;

            input {
                display: block;
                flex: 1;
                width: 100%;
                height: 100%;
                margin-left: 1vw;
                font-size: 2.67vw;
                border: none;
                background-color: transparent;
            }
        }

        .ScanCodeBtn {
            width: 4.27vw;
            height: 4.27vw;
            margin-left: 3.87vw;
        }
    }

    .storeList {
        width: 91.73vw;
        margin: 0 auto;

        .loadingMoreBtn {
            display: block;
            width: 100%;
            border: none;
            margin-top: 4.4vw;
            height: 6.93vw;
            font-size: 2.93vw;
            color: #fff;
            background-color: #43a2fe;
            border-radius: 1.33vw;
        }
    }

    input[type="search"] {
        -webkit-appearance: none;
        // 也可以去除加上border: 0;之类的 根据设计图来
    }

    input::-webkit-search-cancel-button {
        display: none;
    }

    // 关闭的按钮
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue